<template>

    <MenuSimple/>
    <HeadingForms/>

    <div class="px-6 surface-overlay relative">

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="flex align-items-start p-4 bg-yellow-100 border-round border-1 border-yellow-300">
                        <i class="pi pi-exclamation-triangle text-yellow-900 text-2xl mr-3"></i>
                        <div class="mr-3">
                            <div class="text-yellow-900 font-medium text-xl mb-2 line-height-1">Attention</div>
                            <p class="m-0 p-0 text-yellow-700 mb-3 line-height-3">Your booking has NOT been submitted.
                                Please try to complete your information again.</p>
                            <BR/>
                            <a class="font-medium text-yellow-900 hover:text-yellow-800 mr-4 no-underline cursor-pointer select-none transition-colors transition-duration-150"
                               @click="processHome">Try Again</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import MenuSimple from "@/components/menu/common/MenuSimple.vue";
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import HeadingForms from "@/components/heading/common/HeadingForms.vue";


export default {
    name: "BookingError",
    components: {
        MenuSimple,
        HeadingForms,
        IsoEvolveFooter,
    },
    methods: {
        processHome() {
            window.location.href = "/#/login";
            window.location.reload();
        },
    }

};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
